import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export function useFloorsForOffices(offices: string[]) {
  const { api } = useTacticHooks();
  return useQuery({
    queryKey: ['organizations.resourcesAll', 'multi-floor', offices],

    queryFn: async () => {
      const promises = offices.map(async (office) => {
        const res = await api.client.organizations.getAllResources({
          officeId: office,
          types: ['area']
        });
        return res.result?.elements
          ? res.result?.elements.filter((x) => x.is_available)
          : [];
      });
      return (await Promise.all(promises)).flat();
    }
  });
}
